import React, { Component } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Configurations } from '../../Utils/Configurations';
import UserPhoto from '../UserPhoto/UserPhoto';

class HistoricoAtendimento extends Component {

    constructor() {
        super();
        this.configurations = new Configurations();
    }

    render() {
        return (
            <div className="card rounded card-historico">
                {this.props.historico.length > 0 && this.props.historico.map((item, index) => {
                    return (
                        <div key={`hist-${index}`} className="card-body border-bottom py-2">
                            <div className="row no-gutters align-items-center">
                                <div className="col-1 py-1">
                                    <span className="badge badge-primary badge-data">
                                        <div className="row no-gutters">
                                            <div className="col-12 text-center">
                                                <p className="dia">{moment(item.dtCriacao).format("DD")}</p>
                                            </div>
                                            <div className="col-12 text-center">
                                                <p className="mes-ano">{moment(item.dtCriacao).format('MMM/YYYY')}</p>
                                            </div>
                                            <div className="col-12 text-center">
                                                <p className="hora">{moment(item.dtCriacao).format('H:mm:ss')}</p>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div className="col-8 py-1 text-justify">
                                    <div className="row no-gutters">
                                        <div className="col-12">
                                            <strong className="acao">Ação: </strong> {item.acao.nomeAcao}.
                                        </div>
                                        <div className="col-12">
                                            {item.detalhes.map((det, index) => {
                                                const _ehidOcorrencia = det.campo.toString() === "idOcorrencia";
                                                const _idOcorrencia = det.valorNovo ? det.valorNovo : det.valorAntigo ? det.valorAntigo : null

                                                return (
                                                    <p key={`det-${index}`} className="m-0"><strong>{det.campo}:</strong>
                                                        {_ehidOcorrencia ? (
                                                            <span className=""> {_idOcorrencia}</span>
                                                        ) : (
                                                                <>
                                                                    {` `}de <span className="font-italic">{det.valorAntigo ? det.valorAntigo : 'nulo'}</span> para <strong className="font-italic">{det.valorNovo ? det.valorNovo : 'nulo'}
                                                                    </strong>
                                                                </>
                                                            )}

                                                        .</p>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3 py-1 text-right">
                                    <div className="d-flex align-items-center justify-content-end">
                                        <strong>Atendente: </strong> <span className="mx-2">{item.nomeUserFukyo}</span>
                                        <UserPhoto src={`${item.fotoUserFukyo}`}></UserPhoto>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default HistoricoAtendimento;